import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
interface GuestCounterProps {
  value: number;
  max: number;
  label?: string;
  hint?: string;
  onChange: (value: number) => void;
}
export function GuestCounter({
  value,
  max,
  label = 'Number of guests',
  hint,
  onChange
}: GuestCounterProps) {
  return <div className="flex flex-wrap items-center justify-between gap-4" data-id="element-121" data-mp="31m4s7tmn63r6">
      <div data-id="element-122" data-mp="2wm8lvnqh208g">
        <p className="text-[15px] text-ink" data-id="element-123" data-mp="2wlyzsb8jsd81">{label}</p>
        <p className="mt-1 text-[13px] text-muted" data-id="element-124" data-mp="2rtp8orvp5746">{hint ?? `Maximum ${max} guests — strictly capped`}</p>
      </div>
      <div className="flex items-center gap-3" data-id="element-125" data-mp="2nt5dvuylifl7">
        <CounterButton label="Remove a guest" disabled={value <= 1} onClick={() => onChange(Math.max(1, value - 1))} data-id="element-126" data-mp="2it9anxxq2s6p">
          <MinusIcon size={16} data-id="element-127" data-mp="2dupmdqvnp4b6" />
        </CounterButton>
        <span className="relative flex h-10 w-10 items-center justify-center overflow-hidden font-display text-2xl text-forest-700" aria-live="polite" data-id="element-128" data-mp="2dwagxghz0n91">
          <AnimatePresence mode="popLayout" initial={false} data-id="element-129" data-mp="3qx0dsxakv0eh">
            <motion.span key={value} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} transition={{
            duration: 0.16,
            ease: [0.23, 1, 0.32, 1]
          }} data-id="element-130" data-mp="3qvfj97o9jhgm">
              {value}
            </motion.span>
          </AnimatePresence>
        </span>
        <CounterButton label="Add a guest" disabled={value >= max} onClick={() => onChange(Math.min(max, value + 1))} data-id="element-131" data-mp="djovrd4k6bzg">
          <PlusIcon size={16} data-id="element-132" data-mp="ife2c0ezwt59" />
        </CounterButton>
      </div>
    </div>;
}
function CounterButton({
  label,
  disabled,
  onClick,
  children
}: {
  label: string;
  disabled: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return <button type="button" aria-label={label} disabled={disabled} onClick={onClick} className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-forest-700/20 text-forest-700 transition-colors duration-150 ease-premium hover:border-gold-400 hover:bg-gold-100 active:scale-95 disabled:opacity-30 disabled:hover:border-forest-700/20 disabled:hover:bg-transparent" data-id="element-133" data-mp="2oa5iz3xvcv8y">
      {children}
    </button>;
}